import { FLAG_ON } from '@/constant';

const SERVICE_KIND_GAKUDOU = 10;

// `$scope.services`（appCtrl が読み込む施設情報）のうち、判定に使う項目。attributes テーブル由来の値は文字列で届く。
export type ContactToScheduleApplyTargetFacility = {
  kind?: number | string | null;
  attributes?: { reserve_schedule_use?: number | string | null } | null;
} | null;

// 施設が連絡即予定反映の対象かを判定する。
// 判定の定義はバックエンドの `ParentContacts::isContactToScheduleApplyTarget` と一致させ、変えるときは保護者アプリの判定もあわせて変える。
// ずれると、連絡が送信時に予定へ反映される施設で「取消済」を選べてしまうなど、画面の表示と実際の扱いが食い違う。
export const isContactToScheduleApplyTarget = (services?: ContactToScheduleApplyTargetFacility): boolean => {
  return (
    Number(services?.kind) === SERVICE_KIND_GAKUDOU && Number(services?.attributes?.reserve_schedule_use) === FLAG_ON
  );
};
